// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_kn-6";
export var emphasizeQuantity = "_kn-3";
export var flatBottomCorners = "_kn-5";
export var productImage = "_kn-0";
export var quantityContainer = "_kn-2";
export var tooltip = "_kn-1";
export var wrapAndEllipsesOverflow = "_kn-4";